// Small trust badge: US flag glyph + "Made in the USA · Ships nationwide".
export function MadeInUSABadge({ variant = "light", className = "" }) {
  const dark = variant === "dark";
  return (
    <span
      className={`inline-flex items-center gap-1.5 border px-2 py-1 font-mono text-[10px] tracking-[0.18em] uppercase font-bold whitespace-nowrap ${
        dark ? "border-white/20 text-white/80" : "border-slate-300 text-kolt-slate-dark bg-white"
      } ${className}`}
      title="Printed and finished in Houston, Texas. Shipping to all 50 states."
      data-testid="made-in-usa-badge"
    >
      <svg viewBox="0 0 19 10" className="w-[19px] h-[10px] shrink-0" aria-hidden="true">
        <rect width="19" height="10" fill="#B22234" />
        {[1, 3, 5, 7, 9].map((y) => <rect key={y} y={y} width="19" height="1" fill="#fff" />)}
        <rect width="8" height="5.5" fill="#3C3B6E" />
        {[[1.3,1],[3.3,1],[5.3,1],[2.3,2.2],[4.3,2.2],[6.3,2.2],[1.3,3.4],[3.3,3.4],[5.3,3.4]].map(([x, y]) => (
          <circle key={`${x}-${y}`} cx={x} cy={y} r="0.45" fill="#fff" />
        ))}
      </svg>
      Made in the USA <span className={dark ? "text-white/40" : "text-slate-400"}>·</span> Ships nationwide
    </span>
  );
}
